<template>
  <svg
    :height="size"
    :width="size"
    fill="none"
    viewBox="0 0 15 15"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :fill="fill"
      d="M13.7499 3.62991L7.49994 9.8699L1.26994 3.62991C1.13572 3.50037 0.956467 3.42798 0.769936 3.42798C0.583405 3.42798 0.404154 3.50037 0.269936 3.62991C0.202976 3.69474 0.149847 3.77247 0.113755 3.85841C0.0776621 3.94434 0.0593542 4.0367 0.0599358 4.12991C0.0581584 4.22328 0.075922 4.316 0.112086 4.4021C0.148251 4.48821 0.202018 4.5658 0.269936 4.62991L6.99994 11.3699C7.06439 11.4377 7.14195 11.4916 7.2279 11.5285C7.31385 11.5654 7.40641 11.5844 7.49994 11.5844C7.59346 11.5844 7.68602 11.5654 7.77197 11.5285C7.85792 11.4916 7.93548 11.4377 7.99994 11.3699L14.7399 4.62991C14.8695 4.49569 14.9419 4.31644 14.9419 4.12991C14.9419 3.94337 14.8695 3.76412 14.7399 3.62991C14.6074 3.50101 14.4298 3.4289 14.2449 3.4289C14.0601 3.4289 13.8825 3.50101 13.7499 3.62991Z"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { iconProps } from '../../IconProps'

export default defineComponent({
  name: 'IconArrowDown',
  props: {
    ...iconProps,
  },
})
</script>
